import { render, staticRenderFns } from "./downlists.vue?vue&type=template&id=03c7f8b0&scoped=true"
import script from "./downlists.vue?vue&type=script&lang=js"
export * from "./downlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7f8b0",
  null
  
)

export default component.exports